






import { Vue, Component, Prop } from 'vue-property-decorator';
import { ICustomStylingClass } from './types/custom.t';
import CustomText from './CustomText.vue'
import CustomContainer from './CustomContainer.vue'

@Component({components: {CustomText, CustomContainer}})
export default class SwatchBackground extends Vue {

  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop({default: '#FFFFFF'})
  color?: string

  @Prop()
  image?: string

  @Prop({default: false})
  isSelected?: boolean

  get style() {
      return {
        ...(this.$props.image ? {
          "background-image": `url(${this.$store.getters["utils/addCacheBusting"](this.$store.getters['endPoints/swatchesPath']() + this.$props.image)})`
        } : {"background": this.$props.color}),
      }
  }

}

